import React, { useState } from "react";
import {
  Col,
  Dialog,
  FabButton,
  Flex,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../../ppui";
import { OrganizationBx, OrganizationEmDetails } from "../../../../pages/style";
import { TbPencil } from "react-icons/tb";
import useEsiService from "./esi-services";
import { ESI_INITIAL_STATE } from "./esi-constant";

const AdminEsiContribution = ({ openSnackbar }) => {
  const {
    esiListinfo,
    setEsi,
    esi,
    errors,
    setErrors,
    handleBlurFn,
    handleChange,
    handleSubmit,
    handleUpdate
  } = useEsiService({ openSnackbar })

  const [open, setOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editEsiId, setEditEsiId] = useState(null);

  //  const handleClickOpen = () => {
  //     setEsi(ESI_INITIAL_STATE);
  //     setOpen(true);
  //     setErrors({});
  //     setIsEditMode(false);
  //   };

  const handleEditModalOpen = (data) => {
    setEsi({
      employee_contribution: data?.employee_contribution,
      employer_contribution: data?.employer_contribution,
      decuction_cycle: data?.decuction_cycle,
    });
    setOpen(true);
    setEditEsiId(data?.esi_id)
    setErrors({});
    setIsEditMode(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEsi(ESI_INITIAL_STATE);
    setErrors({});
  };

  const handleSubmitFn = async () => {
    let success = false;
    if (editEsiId) {
      success =  await handleUpdate(editEsiId)
    } else {
      success =  await handleSubmit();
    }

    if (!success) {
      setOpen(true);
    } else{
      setOpen(false);
    }
  };

  return (
    <>
      <Flex justifyContent="space-between" mb={18} gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Esi Contribution
        </Typography>

        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={() => handleEditModalOpen(esiListinfo[0])}
          variant="filled"
          shape="box"
        />
      </Flex>

      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Deduction Cycle
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            {esiListinfo[0]?.decuction_cycle}
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            {`Employee's`} Contribution
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            ₹ {esiListinfo[0]?.employee_contribution}
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            {` Employer's`} Contribution
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            ₹ {esiListinfo[0]?.employer_contribution}
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>

      {/* labour-welfare */}
      <Dialog
        title={isEditMode ? "ESI" : "ESI"}
        closeButton={true}
        fullWidth
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFn}
        separator
        bodyScroll={true}
      >
        <Row rowGap={20}>
          <Col sm={12} >
            <SelectField
              fullWidth
              required
              label="Deduction"
              options={[
                { id: "Monthly", name: "Monthly" },
                { id: "Half Yearly", name: "Half Yearly" },
                { id: "Yearly", name: "Yearly" },
              ]}
              placeholder="Select Here..."
              defaultValue={esi?.decuction_cycle}
              onChange={(val) => handleChange(val, "decuction_cycle")}
              error={errors?.decuction_cycle}
              helperText={errors?.decuction_cycle}
              onBlur={(e) => handleBlurFn(e, "decuction_cycle")}
            />
          </Col>
          <Col sm={12} >
            <InputField
              required
              fullWidth
              label="Employee's Contribution"
              type="text"
              placeholder="Type Here"
              valueSinc={!!esi?.employee_contribution}
              value={esi?.employee_contribution}
              onChange={(e) => handleChange(e.target.value, "employee_contribution")}
              helperText={errors?.employee_contribution}
              error={errors?.employee_contribution}
              onBlur={(e) => handleBlurFn(e, "employee_contribution")}
            />
          </Col>
          <Col sm={12} >
            <InputField
              required
              fullWidth
              label="Employer's Contribution"
              type="text"
              placeholder="Type Here"
              valueSinc={!!esi?.employer_contribution}
              value={esi?.employer_contribution}
              onChange={(e) => handleChange(e.target.value, "employer_contribution")}
              helperText={errors?.employer_contribution}
              error={errors?.employer_contribution}
              onBlur={(e) => handleBlurFn(e, "employer_contribution")}
            />
          </Col>
        </Row>
      </Dialog>

      {/* labour-welfare */}
    </>
  );
};

export default AdminEsiContribution;
